module.exports = __webpack_public_path__ + "img/user.bba17504.jpg";